import { CircularProgress, TablePagination } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { invokeApi } from "../../../../bl_libs/invokeApi";
import moment from "moment";
function TotalHours() {
  const [totalHours, setTotalHours] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  //------------------------------------------>  pagination settings
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [totalCount, setTotalCount] = useState(0);

  //----------------------------------------------------------------

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const FetchTotalHours = () => {
    let requestObj = {
      path: `/api/foreman/foreman_total_hours?page=${page}&limit=${rowsPerPage}`,
      method: "GET",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    setIsLoading(true);
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        console.log(res, "FETCH_TOTAL_HOURS");
        setTotalHours(res.data_array);
        setTotalCount(res.get_foreman_completed_request_count);
        setIsLoading(false);
      } else {
      }
    });
  };

  const destructureMinutes = (minutes) => {
    var hours = parseInt(minutes) / 60;
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);

    if (rhours === 0) {
      return rminutes + " min";
    }
    return rhours + " hr " + rminutes + " min";
  };

  const getTotalHours = () => {
    let minutes = 0;

    totalHours.map((req) => {
      req.move_time.map((time) => {
        if (time.type !== 2) {
          // ignore Break time
          minutes += parseInt(time.total_hours);
        }
      });
    });
    var hours = parseInt(minutes) / 60;
    var rhours = Math.floor(hours);
    minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);

    return rhours + " hour(s) and " + rminutes + " minute(s)";
  };

  useEffect(() => {
    FetchTotalHours();
  }, [page, rowsPerPage]);

  if (isLoading) {
    return (
      <>
        <div className="Circular-Progress">
          <CircularProgress />
        </div>
      </>
    );
  }

  if (window.innerWidth < 500) {
    console.log(window.innerWidth, "Width");
    return (
      <>
        <div className="row">
          <div className="col-12 col-sm-3">
            <p className="small-text-bold">My Hours</p>
          </div>
          <div className="col-12 col-sm-9 text-right">
            <span className="sub-title dark-grey-color">Total: </span>
            <span>{getTotalHours()}</span>
          </div>
        </div>
        <div className="rounded-box pb-3">
          <div className="row">
            <div className="col-12">
              <table
                id="example"
                className="responsive table table-hover"
                style={{ width: "100%" }}
              >
                <thead>
                  <th className="small-sub-title dark-grey-color">
                    <div className="row">
                      <div className="col-6 small-sub-title dark-grey-color">
                        Request
                      </div>
                      <div className="col-6"></div>
                    </div>
                  </th>
                </thead>
                <tbody>
                  {totalHours.map((req, i) => (
                    <tr
                      key={req.request.id}
                      className="pointer-point border-bottom"
                    >
                      <div className="row pl-2">
                        <div className="col-4 small-sub-title dark-grey-color">
                          Request No.
                        </div>
                        <div className="col-8 small-sub-title dark-grey-color">
                          #{req.request.id}
                        </div>
                        <div className="col-4 small-sub-title dark-grey-color">
                          <span className="">Date:</span>
                        </div>
                        <div className="col-8">
                          {req.request.schedule_time.slice(0, 11)}
                        </div>

                        <div className="col-4 small-sub-title dark-grey-color">
                          <span className="">Time:</span>
                        </div>
                        <div className="col-8">
                          {req.request.schedule_time.slice(
                            11,
                            req.request.schedule_time.length
                          )}
                        </div>

                        <div className="col-4 small-sub-title dark-grey-color">
                          <span className="">Distance:</span>
                        </div>
                        <div className="col-8">{req.request.net_distance} </div>
                        <div className="col-4 small-sub-title dark-grey-color">
                          <span className="">Move Type:</span>
                        </div>
                        <div className="col-8">{req.request.move_type}</div>

                        <div className="col-4 small-sub-title dark-grey-color">
                          <span className="">Truck:</span>
                        </div>
                        <div className="col-8">
                          {req.truck.map(
                            (singleTruck, i) =>
                              singleTruck.name +
                              (i === req.truck.length - 1 ? "" : ", ")
                          )}
                        </div>
                        <div className="col-4 small-sub-title dark-grey-color">
                          <span className="">Drive Time:</span>
                        </div>
                        <div className="col-8">
                          {destructureMinutes(
                            req.move_time.find((time) => time.type === 0)
                              .total_hours
                          )}
                        </div>
                        <div className="col-4 small-sub-title dark-grey-color">
                          <span className="">Move Time:</span>
                        </div>
                        <div className="col-8">
                          {destructureMinutes(
                            req.move_time.find((time) => time.type === 1)
                              .total_hours
                          )}
                        </div>
                        <div className="col-4 small-sub-title dark-grey-color">
                          <span className="">Break Time:</span>
                        </div>
                        <div className="col-8">
                          {destructureMinutes(
                            req.move_time.find((time) => time.type === 2)
                              .total_hours
                          )}
                        </div>
                        <div className="col-4 small-sub-title dark-grey-color">
                          <span className="">Last update:</span>
                        </div>
                        <div className="col-8">
                          <span className="light-grey-color extra-small-font-size">
                            Updated {moment(req.request.updated_at).fromNow()}
                          </span>
                        </div>
                      </div>
                    </tr>
                  ))}
                </tbody>
              </table>
              <TablePagination
                component="div"
                count={totalCount}
                page={page}
                onChangePage={handleChangePage}
                rowsPerPage={rowsPerPage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                labelRowsPerPage={
                  <span className="pagination-text">Rows:</span>
                }
              />
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      {/* <!--Trucks & Foreman Box--> */}
      <div className="truck-foreman-wrapper mt-30">
        <div className="row">
          <div className="col-12 col-sm-3">
            <p className="small-text-bold">My Hours</p>
          </div>
          <div className="col-12 col-sm-9 text-right">
            <span className="sub-title dark-grey-color">Total: </span>
            <span>{getTotalHours()}</span>
          </div>
        </div>
        <div className="rounded-box pb-3 mt-2 min-width-650">
          <div className="row">
            <div className="col-12">
              <table id="example" className="responsive table table-hover">
                <thead>
                  <tr>
                    <th className="small-sub-title dark-grey-color">
                      Request number
                    </th>
                    <th className="small-sub-title dark-grey-color">Date</th>
                    <th className="small-sub-title dark-grey-color">
                      Distance
                    </th>
                    <th className="small-sub-title dark-grey-color">
                      Move Type
                    </th>
                    <th className="small-sub-title dark-grey-color">Truck</th>
                    <th className="small-sub-title dark-grey-color">
                      Drive Time
                    </th>
                    <th className="small-sub-title dark-grey-color">
                      Move Time
                    </th>
                    <th className="small-sub-title dark-grey-color">
                      Break Time
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {totalHours.map((req, i) => (
                    <tr key={i}>
                      <td>
                        <a
                          // href="request-detail.html"
                          className="request-link"
                        >
                          #{req.request.id}
                          <br />
                          <span className="light-grey-color extra-small-font-size">
                            Updated {moment(req.request.updated_at).fromNow()}
                          </span>
                        </a>
                      </td>
                      <td>{req.request.schedule_time}</td>
                      <td>{req.request.net_distance} mi</td>
                      <td>{req.request.move_type}</td>
                      <td>
                        {req.truck.map(
                          (singleTruck, i) =>
                            singleTruck.name +
                            (i === req.truck.length - 1 ? "" : ", ")
                        )}
                      </td>
                      {/* Drive Time */}
                      <td>
                        {destructureMinutes(
                          req.move_time.find((time) => time.type === 0)
                            .total_hours
                        )}
                      </td>
                      {/* Move Time */}
                      <td>
                        {destructureMinutes(
                          req.move_time.find((time) => time.type === 1)
                            .total_hours
                        )}
                      </td>
                      {/* Break Time */}
                      <td>
                        {destructureMinutes(
                          req.move_time.find((time) => time.type === 2)
                            .total_hours
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <TablePagination
                component="div"
                count={totalCount}
                page={page}
                onChangePage={handleChangePage}
                rowsPerPage={rowsPerPage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                labelRowsPerPage={
                  <span className="pagination-text">Rows per page:</span>
                }
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TotalHours;
